var React = require('react');

function L (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.460205 -6.10352e-05V0.329937C3.29821 0.329937 3.49621 2.67294 3.49621 9.17394V23.8259C3.49621 30.3269 3.29821 32.6699 0.460205 32.6699V32.9999H24.0552V27.5549H23.7252C23.7252 32.3069 13.6602 32.6699 10.5252 32.6699H6.33421V9.17394C6.33421 2.67294 6.53221 0.329937 9.37021 0.329937V-6.10352e-05H0.460205Z","fill":"currentColor"}));
}

L.defaultProps = {"width":"25","height":"33","viewBox":"0 0 25 33","fill":"none"};

module.exports = L;

L.default = L;
